import React, { FC, RefObject, MutableRefObject } from 'react';
import { Grid } from '@mui/material';
import { Page } from 'features/document/documentSlice';
import { useAppSelector } from 'app/hooks';
import ThumbnailSidebar from 'pages/DocumentBuilder/components/PageBuilder/components/ThumbnailSidebar/ThumbnailSidebar';
import ViewerThumbnailSidebar from './components/ViewerThumbnailBar/ViewerThumbnailBar';
import ViewerPage from '../ViewerPage/ViewerPage';
import { Page as ReactPdf, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import styles from './ViewerBody.module.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface Props {
  hasPdf: boolean;
  currentPage: number;
  pages: Page[];
  pagesRef: MutableRefObject<RefObject<HTMLDivElement>[]>;
  thumbnailPagesRef: MutableRefObject<RefObject<HTMLDivElement>[]>;
  scrollToPage: (pageIndex: number, fromThumbnail: boolean) => void;
}

const ViewerBody: FC<Props> = ({ hasPdf, currentPage, pages, pagesRef, thumbnailPagesRef, scrollToPage }) => {
  const selector = useAppSelector;
  const isSidebarOpen = selector(state => state.document.isSidebarOpen);

  return (
    <Grid className={styles.workspace}>
      {isSidebarOpen &&
        (hasPdf ? (
          <ViewerThumbnailSidebar
            currentPage={currentPage}
            pages={pages}
            thumbnailPagesRef={thumbnailPagesRef}
            scrollToPage={scrollToPage}
          />
        ) : (
          <ThumbnailSidebar pages={pages} thumbnailPagesRef={thumbnailPagesRef} scrollToPage={scrollToPage} />
        ))}
      <Grid
        id={'document-window'}
        container
        className={`${styles.container} ${isSidebarOpen ? '' : styles.containerShift}`}
        justifyContent='center'
        direction='column'
        alignContent='center'
        gap={8}
      >
        <Grid item>
          {hasPdf
            ? [...Array(pages.length)].map((_, index) => (
                <div id={pages[index].id} key={`page_${index + 1}`} ref={pagesRef.current[index]}>
                  <ReactPdf className={styles.page} pageNumber={index + 1} height={1054} width={816} scale={1} />
                </div>
              ))
            : pages.map((page: Page, index) => (
                <Grid item key={page.id} ref={pagesRef.current[index]}>
                  <ViewerPage key={page.id} content={page} pageNumber={index + 1} totalPages={pages.length} />
                </Grid>
              ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ViewerBody;
